import { trackContentEngagement } from '../../js/front/analytics';

/**
 * Sends content_engagement the first time each accordion item is expanded.
 *
 * @param {HTMLElement} block Accordion root element.
 * @return {void}
 */
const initBlock = ( block ) => {

	block.querySelectorAll( '.b-accordion__item' ).forEach( ( item ) => {

		/**
		 * Tracks the first expansion of the item, then stops listening.
		 *
		 * @return {void}
		 */
		const handleToggle = () => {

			if ( ! item.open ) {

				return;

			}

			item.removeEventListener( 'toggle', handleToggle );
			trackContentEngagement( block, 'accordion_expand', 'accordion_element' );

		};

		item.addEventListener( 'toggle', handleToggle );

	} );

};

document.querySelectorAll( '.b-accordion' ).forEach( initBlock );
